/* ============================================================
 * N36 PAIRS WELL WITH — native cart drawer cross-sell band (v1)
 * Replaces the iCart cross-sell. ES5-safe syntax (var/function,
 * no arrows, no template literals). Browser APIs: fetch, Promise,
 * querySelector — all already required by the native-cart plumbing.
 *
 * HARD GATE: does absolutely nothing unless window.N36_NATIVE_CART
 * is true at load time (flag-off customers never see or run this).
 *
 * Wiring: listens for the 'n36cart:updated' document event. If the
 * event carries cart JSON in event.detail (an object with .items),
 * it uses that; otherwise it fetches /cart.js itself. Also does one
 * initial render on load from /cart.js.
 *
 * Adds POST /cart/add.js through window.fetch ON PURPOSE so the
 * native-cart plumbing's fetch hook sees the add and auto-refreshes
 * the drawer, which re-dispatches n36cart:updated, which re-renders
 * this band (the just-added product drops out automatically).
 *
 * Storefront quirk honored: the container is created via JS with
 * inline base styles and is only inserted AFTER it has children —
 * an empty div is never placed in the DOM.
 *
 * v1 ships NO discounts. Discounted cross-sell pricing needs a
 * cart-transform / discount function (deferred, see notes).
 * ============================================================ */
(function () {
  'use strict';

  if (!window.N36_NATIVE_CART) return; // inert for all real customers
  if (window.N36PairsWith) return;     // idempotent if loaded twice
  window.N36PairsWith = true;

  /* ------------------------------------------------------------
   * PRODUCT CATALOG — the things we can offer.
   * Resolved live 2026-08-15 (all ACTIVE, in stock; see
   * pairs-with-notes.md). Prices are whole dollars (house rule).
   * variantId is the numeric variant id /cart/add.js wants.
   * ---------------------------------------------------------- */
  var PRODUCTS = {
    'superior-salt-mix': {
      title: 'Superior Salt Mix',
      handle: 'superior-salt-mix',
      variantId: 49608145207543,
      price: 15,
      image: 'https://cdn.shopify.com/s/files/1/0870/6300/3383/files/AcmeSuperiorSaltMixShopify.jpg?v=1744920322&width=180'
    },
    'stk-blend': {
      title: 'STK Blend',
      handle: 'stk-blend',
      variantId: 49608145043703,
      price: 20,
      image: 'https://cdn.shopify.com/s/files/1/0870/6300/3383/files/SteakBlendSeasoningShopify.jpg?v=1744920314&width=180'
    },
    'johnson-family-salsa': {
      title: 'Johnson Family Salsa',
      handle: 'johnson-family-salsa',
      variantId: 50686050074871,
      price: 12,
      image: 'https://cdn.shopify.com/s/files/1/0870/6300/3383/files/JohnsonFamilySalsa.jpg?v=1776376146&width=180'
    },
    'smashburger-press': {
      title: 'Smashburger Press',
      handle: 'smashburger-press',
      variantId: 49687948198135,
      price: 40,
      image: 'https://cdn.shopify.com/s/files/1/0870/6300/3383/files/BurgerPressProductShot.jpg?v=1747680750&width=180'
    },
    'assorted-box-of-cookies': {
      title: 'Assorted Box of Cookies',
      handle: 'assorted-box-of-cookies',
      variantId: 49706067067127, /* 6-count, $24 (12-count $48 exists; 6 chosen for v1) */
      price: 24,
      image: 'https://cdn.shopify.com/s/files/1/0870/6300/3383/files/Untitleddesign_22.jpg?v=1749500470&width=180'
    },
    'bone-marrow': {
      title: 'Marrow Bones 1 lb',
      handle: 'bone-marrow',
      variantId: 49608142487799,
      price: 15,
      image: 'https://cdn.shopify.com/s/files/1/0870/6300/3383/files/BoneMarrowRawShopify.jpg?v=1744920230&width=180'
    },
    /* ---- CUTS (v2.3, Asher 2026-08-15: upsell high-value product, not
       bits and bobs; skirts in every band). Variants pinned to the size
       we feature; price/image/availability HYDRATED LIVE from
       /products/<handle>.js at render so a sold-out cut silently drops
       and prices can never go stale. Static price here is only the
       pre-hydration fallback. Rotate this roster at the monthly
       stock review. */
    'outside-skirt-steak': {
      title: 'Outside Skirt 2 lb',
      handle: 'outside-skirt-steak',
      variantId: 49705343549687,
      price: 69
    },
    'dry-aged-ribeye': {
      title: 'Ribeye 16-18 oz',
      handle: 'dry-aged-ribeye',
      variantId: 50538230546679,
      price: 47
    },
    'dry-aged-new-york-strip': {
      title: 'NY Strip 10-12 oz',
      handle: 'dry-aged-new-york-strip',
      variantId: 50538118775031,
      price: 25
    },
    'denver-steak': {
      title: "Butcher's Cut Denver",
      handle: 'denver-steak',
      variantId: 49701225103607,
      price: 15
    },
    'big-daddy-hamburgers': {
      title: 'Big Daddy Burgers x4',
      handle: 'big-daddy-hamburgers',
      variantId: 49608143798519,
      price: 35
    },
    'ground-beef': {
      title: 'Ground Beef 1 lb',
      handle: 'ground-beef',
      variantId: 49608144158967,
      price: 11
    },
    'flank-steak': {
      title: 'Flank 32-40 oz',
      handle: 'flank-steak',
      variantId: 49635675144439,
      price: 53
    },
    /* ---- Farm Specials pool additions (2026-08-21): the rest of Asher's
       signed pool + the premiere cuts. Premiere cuts only surface when they
       carry a configured special (no unsigned discounts). Images/prices
       hydrate live; a pinned size that sells out falls back to the next
       available size at hydrate. */
    'fajita-steak':  { title: 'Fajita Steak 1 lb', handle: 'fajita-steak', variantId: 49635675242743, price: 18 },
    'tritip':        { title: 'Tri-Tip 1-2 lbs', handle: 'tritip', variantId: 49705402826999, price: 32 },
    'smoky-maple':   { title: 'Smoky Maple Seasoning', handle: 'smoky-maple', variantId: 50754225766647, price: 15 },
    'bbq-rub':       { title: 'BBQ Rub', handle: 'bbq-rub', variantId: 49608145076471, price: 14 },
    'dry-aged-bone-in-filet-mignon': { title: 'Bone-In Filet 16-24 oz', handle: 'dry-aged-bone-in-filet-mignon', variantId: 50933407023351, price: 74 },
    'dry-aged-filet-mignon':         { title: 'Filet Mignon 12-14 oz x2', handle: 'dry-aged-filet-mignon', variantId: 50670616609015, price: 109 },
    'dry-aged-porterhouse':          { title: 'Porterhouse 24-28 oz', handle: 'dry-aged-porterhouse', variantId: 50754080440567, price: 93 },
    'dry-aged-tomahawk-ribeye':      { title: 'Tomahawk 32 oz', handle: 'dry-aged-tomahawk-ribeye', variantId: 50221796983031, price: 79 },
    'dry-aged-bone-in-ribeye':       { title: 'Bone-In Ribeye 24 oz', handle: 'dry-aged-bone-in-ribeye', variantId: 50888740274423, price: 48 },
    /* ---- Pairs-well-with additions (Asher 2026-08-22, option B: all in the
       pool with a small deal). Sizes pinned per Asher; hydrate falls back to
       the next available size if a pinned one sells out. */
    'bone-in-short-rib':  { title: 'Bone-In Short Rib 3 lb', handle: 'bone-in-short-rib', variantId: 49703626211575, price: 52 },
    'picanha-steak':      { title: 'Picanha 12-16 oz', handle: 'picanha-steak', variantId: 49705402007799, price: 19 },
    'inside-skirt-steak': { title: 'Inside Skirt 8-16 oz', handle: 'inside-skirt-steak', variantId: 50993287954679, price: 28 },
    'pappy-company-bourbon-barrel-stave-smoking-chunks': { title: 'Pappy Bourbon Barrel Smoking Chunks', handle: 'pappy-company-bourbon-barrel-stave-smoking-chunks', variantId: 50695737508087, price: 39 },
    'laguiole-steak-knives': { title: 'Laguiole Steak Knives', handle: 'laguiole-steak-knives', variantId: 49688249565431, price: 69 },
    /* ---- Wild-Caught Fish (2026-08-28): portions pair with smaller steaks,
       filets with the large formats. Weights in the title for the non-variant
       portions; filet cards show the entry band. */
    'wild-alaskan-king-salmon': { title: 'Wild King Salmon 8 oz', handle: 'wild-alaskan-king-salmon', variantId: 51051861737719, price: 25, image: 'https://cdn.shopify.com/s/files/1/0870/6300/3383/files/n36-salmon-portion.jpg?v=1787955207&width=180' },
    'wild-alaskan-halibut':     { title: 'Wild Halibut 8 oz', handle: 'wild-alaskan-halibut', variantId: 51051861770487, price: 24, image: 'https://cdn.shopify.com/s/files/1/0870/6300/3383/files/n36-halibut-portion-2.jpg?v=1787955207&width=180' },
    /* 2026-10-08 (Asher: "add cod to the cart band to show up when steaks are in cart") */
    'wild-alaskan-black-cod':   { title: 'Wild Black Cod 5-8 oz', handle: 'wild-alaskan-black-cod', variantId: 51273013919991, price: 14 },
  };

  /* premiere cuts: rare appearance in the Farm Specials pool (~1 in 4 visits,
     one card), and only when configured as a special */
  var PREMIERE = {
    'dry-aged-bone-in-filet-mignon': 1, 'dry-aged-filet-mignon': 1, 'dry-aged-porterhouse': 1,
    'dry-aged-tomahawk-ribeye': 1, 'dry-aged-bone-in-ribeye': 1
  };

  /* accessories never TRIGGER rules (a Smashburger Press in the cart is
     not a burger); cuts in the roster are real rule-matchers */
  var ACCESSORY = {
    'superior-salt-mix': 1, 'stk-blend': 1, 'johnson-family-salsa': 1,
    'smashburger-press': 1, 'assorted-box-of-cookies': 1, 'bone-marrow': 1,
    'smoky-maple': 1, 'bbq-rub': 1,
    'pappy-company-bourbon-barrel-stave-smoking-chunks': 1, 'laguiole-steak-knives': 1
  };

  /* ------------------------------------------------------------
   * PAIRS WELL WITH — contextual pairing engine (Asher 2026-08-22).
   * Each pair: `match` keywords (lowercased substring vs cart line title +
   * handle; pantry lines in the cart never drive a match), `cuts` that take
   * the leading CUT slots, `pantry` candidates for the single CABOOSE slot.
   * Pairings are recomputed from the CURRENT cart on every render so they
   * track changes; only the random shuffle-FILL is frozen per session.
   *
   * PRIORITY = list order, first hit wins the caboose. Ordered by the
   * caboose's dollar value (Asher: "highest dollar item"), except GIFT which
   * leads on intent: a handwritten note / gift card is an explicit signal.
   *   gift -> Cookies $22 | steak -> Knives $64 | burger -> Press $37 |
   *   brisket -> Pappy $36 | roast -> Rub $13 | fajita/flank -> Salsa $11 |
   *   soup bones -> Marrow $13
   * The steak list is SPECIFIC cut names only — never the bare word "steak" —
   * so "Fajita Steak" / "Skirt Steak" / "Flank Steak" fall to their own pair.
   * Only CONFIGURED specials are ever offered (pool mode): an item stays
   * hidden until farm-picks.json is synced, so pushing this ahead of the
   * sync is safe.
   * ---------------------------------------------------------- */
  var STEAK_CUTS = ['ribeye', 'rib eye', 'new york strip', 'ny strip', 'filet', 'porterhouse',
                    'tomahawk', 't-bone', 't bone', 'denver', 'tri-tip', 'tritip', 'picanha',
                    'bavette', 'flat iron', 'sirloin', 'butcher'];
  var PAIRS = [
    { name: 'gift',    match: [], gift: true,
      cuts: [], pantry: ['assorted-box-of-cookies'] },
    { name: 'steak',   match: STEAK_CUTS, exclude: ['ground'], /* Ground Sirloin is a burger, not a steak */
      cuts: ['denver-steak'],
      pantry: ['laguiole-steak-knives', 'stk-blend', 'superior-salt-mix', 'bone-marrow'] },
    { name: 'burger',  match: ['ground beef', 'ground sirloin', 'burger', 'burgers', 'hamburger', 'patty', 'patties', 'smash'],
      cuts: [], pantry: ['smashburger-press', 'stk-blend', 'bbq-rub'] },
    { name: 'brisket', match: ['brisket'],
      cuts: ['bone-in-short-rib', 'picanha-steak', 'tritip'],
      pantry: ['pappy-company-bourbon-barrel-stave-smoking-chunks', 'bbq-rub', 'smoky-maple'] },
    { name: 'roast',   match: ['roast', 'chuck', 'short rib', 'shank', 'stew'],
      cuts: [], pantry: ['bbq-rub', 'smoky-maple'] },
    { name: 'flank',   match: ['flank'],
      cuts: ['inside-skirt-steak', 'outside-skirt-steak'], pantry: ['johnson-family-salsa', 'bbq-rub'] },
    { name: 'fajita',  match: ['fajita', 'skirt'],
      cuts: [], pantry: ['johnson-family-salsa', 'bbq-rub'] },
    { name: 'soup',    match: ['soup bone', 'soup bones'],
      cuts: [], pantry: ['bone-marrow'] },
    { name: 'fish', match: STEAK_CUTS,
      cuts: ['wild-alaskan-king-salmon', 'wild-alaskan-halibut', 'wild-alaskan-black-cod'], pantry: [] }
  ];
  /* items that appear ONLY via a pairing — never in the random shuffle fill,
     never as the random caboose. Keeps the everyday shuffle to Asher's signed
     roster; the pairing cuts are curated companions, not general filler. */
  var PAIRING_ONLY = { 'smashburger-press': 1, 'laguiole-steak-knives': 1,
                       'pappy-company-bourbon-barrel-stave-smoking-chunks': 1,
                       'bone-in-short-rib': 1, 'picanha-steak': 1, 'inside-skirt-steak': 1,
                       'wild-alaskan-king-salmon': 1, 'wild-alaskan-halibut': 1,
                       'wild-alaskan-black-cod': 1 };

  /* gift signal: the "Include a handwritten note" field (cart.note) is filled,
     or a gift card is in the cart */
  function cartIsGift(cart) {
    if (cart && typeof cart.note === 'string' && cart.note.replace(/\s+/g, '') !== '') return true;
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].gift_card === true) return true;
      if (lineText(items[i]).indexOf('gift card') !== -1) return true;
    }
    return false;
  }

  function pairHits(pair, cart, items) {
    if (pair.gift) return cartIsGift(cart);
    for (var i = 0; i < items.length; i++) {
      if (items[i].handle && ACCESSORY[items[i].handle]) continue; /* pantry in cart never drives pairing */
      var text = lineText(items[i]);
      if (pair.exclude && pair.exclude.length && anyKeyword(text, pair.exclude)) continue; /* veto (e.g. "ground" vs steak) */
      if (anyKeyword(text, pair.match)) return true;
    }
    return false;
  }

  /* a configured, in-stock-eligible, not-in-cart offer key — else null */
  function offerable(h, inCart) {
    var p = PRODUCTS[h];
    if (!p) return null;
    if (!Object.prototype.hasOwnProperty.call(FARM_PICKS, h)) return null; /* configured specials only */
    if (inCart[p.handle] || inCart['v' + p.variantId]) return null;        /* never offer what's in the cart */
    return h;
  }

  /* leading CUT slots: every matched pair's cuts, in priority order, deduped */
  function cutPairsFor(cart, items, inCart, limit) {
    var out = [], seen = {};
    for (var r = 0; r < PAIRS.length && out.length < limit; r++) {
      if (!pairHits(PAIRS[r], cart, items)) continue;
      var cuts = PAIRS[r].cuts || [];
      for (var c = 0; c < cuts.length && out.length < limit; c++) {
        var h = offerable(cuts[c], inCart);
        if (h && !seen[h]) { seen[h] = true; out.push(h); }
      }
    }
    return out;
  }

  /* the pantry CABOOSE candidates, best first: the first pair to hit wins and
     its list is tried in order; later hits' lists follow as stand-ins (a
     sold-out primary falls to the next candidate after hydrate). */
  function pantryPairFor(cart, items, inCart) {
    var out = [], seen = {};
    for (var r = 0; r < PAIRS.length; r++) {
      if (!pairHits(PAIRS[r], cart, items)) continue;
      var want = PAIRS[r].pantry || [];
      for (var w = 0; w < want.length; w++) {
        var h = offerable(want[w], inCart);
        if (h && !seen[h]) { seen[h] = true; out.push(h); }
      }
    }
    return out;
  }

  /* ------------------------------------------------------------
   * RULE MAP — edit me.
   * Evaluated top to bottom. 'match' keywords are lowercased
   * substring checks against each cart line's product title AND
   * handle. 'exclude' keywords veto a line (so Ground Sirloin
   * never trips the steak rule via "sirloin"). Every matching
   * rule contributes its 'offer' list in order; results are
   * deduped, anything already in the cart is dropped, and the
   * band caps at MAX_CARDS. FALLBACK_OFFER is used only when the
   * cart is non-empty and no rule matched. Lines whose handle is
   * one of our own offer products are ignored during matching
   * (the Smashburger Press must not trigger the burger rule).
   * ---------------------------------------------------------- */
  var RULES = [
    {
      name: 'fajita', /* first so the skirt-led order wins the top slots */
      match: ['fajita'],
      exclude: [],
      offer: ['outside-skirt-steak', 'flank-steak', 'dry-aged-new-york-strip', 'johnson-family-salsa']
    },
    {
      name: 'ground-burger', /* burger buyers see the good stuff */
      match: ['ground beef', 'ground sirloin', 'burger', 'patty', 'patties'],
      exclude: [],
      offer: ['outside-skirt-steak', 'dry-aged-ribeye', 'dry-aged-new-york-strip', 'denver-steak', 'smashburger-press']
    },
    {
      name: 'steak', /* steak buyers pad the freezer */
      match: [
        'new york strip', 'ribeye', 'rib eye', 'filet', 'sirloin', 't-bone',
        't bone', 'denver', 'bavette', 'flat iron', 'tomahawk', 'picanha'
      ],
      exclude: ['ground'], /* Ground Sirloin belongs to the burger rule */
      offer: ['outside-skirt-steak', 'big-daddy-hamburgers', 'ground-beef', 'bone-marrow', 'stk-blend']
    }
  ];
  var FALLBACK_OFFER = ['dry-aged-new-york-strip', 'outside-skirt-steak', 'dry-aged-ribeye', 'ground-beef', 'superior-salt-mix'];
  var MAX_CARDS = 5; /* 6 -> 4 (Asher 2026-08-21) -> 5 (Asher 2026-08-22: room for 3 paired cuts + a filler + the caboose) */

  var BAND_ID = 'n36-pairs-with';
  var BAND_TITLE = 'Pairs well with…'; /* Asher 2026-08-22, verbatim — shown while specials are armed (was "Farm Specials") */
  var BAND_TITLE_PLAIN = 'Suggestions from the farm'; /* Asher's copy, verbatim, 2026-08-15 — shown when no specials are configured */

  /* ---- palette (box-builder tokens, inlined) ---- */
  var C = {
    slate: '#363C46',
    olive: '#6E6656',
    oxblood: '#7A332B',
    linen: '#F6F2EA',
    surface: '#FCFAF4',
    line: 'rgba(54,60,70,.14)',
    lineSoft: 'rgba(110,102,86,.28)'
  };
  var BODY_FONT = '"F37 Lineca","Hanken Grotesk",-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif';

  /* ------------------------------------------------------------
   * Matching
   * ---------------------------------------------------------- */
  function lineText(item) {
    return ((item.product_title || item.title || '') + ' ' + (item.handle || '')).toLowerCase();
  }

  function anyKeyword(text, keywords) {
    for (var i = 0; i < keywords.length; i++) {
      if (text.indexOf(keywords[i]) !== -1) return true;
    }
    return false;
  }

  function isCatalogHandle(handle) {
    return !!(handle && PRODUCTS[handle]);
  }

  /* ---- Farm Specials POOL + SHUFFLE (Asher 2026-08-20/21) ----
     When specials are configured the band ignores the rules matrix and
     draws from the pool of CONFIGURED specials: cuts shuffled (seeded once
     per page load so re-renders don't reshuffle under the customer),
     premiere cuts surface rarely (~1 in 4 visits, one card), one pantry
     item rides caboose. Anything in the cart is never offered; sold-out
     sizes fall back at hydrate; cuts with nothing available drop. Over-
     selects so stockouts don't leave holes (trimmed after hydrate). */
  var SEED = Math.floor(Math.random() * 2147483646) + 1;
  var PREMIERE_ROLL = Math.random() < 0.25;
  function seededShuffle(list) {
    var a = list.slice(), s = SEED;
    function rnd() { s = (s * 48271) % 2147483647; return s / 2147483647; }
    for (var i = a.length - 1; i > 0; i--) { var k = Math.floor(rnd() * (i + 1)); var t = a[i]; a[i] = a[k]; a[k] = t; }
    return a;
  }
  /* "You get the offers you get" (Asher 2026-08-21): the first six the visitor
     sees are THE offers for that browser session. Adding one removes it from
     the band; nothing backfills. Persisted in sessionStorage so it holds across
     pages; a fresh session draws a fresh set. */
  var FIXED_KEY = 'n36fs:offers:v2'; /* v2 (2026-08-22): stores the frozen shuffle ORDER; pairings + caboose are never frozen */
  function loadFixed() { try { var s = window.sessionStorage.getItem(FIXED_KEY); return s ? JSON.parse(s) : null; } catch (e) { return null; } }
  function saveFixed(keys) { try { window.sessionStorage.setItem(FIXED_KEY, JSON.stringify(keys)); } catch (e) {} }
  /* v3 (Asher 2026-09-04): freeze THE VISIBLE SET, not just the shuffle order. The
     five cards the customer first sees are their five for the session; adding one
     removes it and NOTHING backfills. (v2 topped every layer back up to the slot
     count on each render, so the band was a conveyor of discounted adds.) A fresh
     session draws a fresh set. */
  var SHOWN_KEY = 'n36fs:shown:v3';
  function loadShown() { try { var s = window.sessionStorage.getItem(SHOWN_KEY); return s ? JSON.parse(s) : null; } catch (e) { return null; } }
  function saveShown(keys) { try { window.sessionStorage.setItem(SHOWN_KEY, JSON.stringify(keys)); } catch (e) {} }
  function inCartMap(items) {
    var m = {};
    for (var i = 0; i < items.length; i++) {
      if (items[i].handle) m[items[i].handle] = true;
      if (items[i].variant_id) m['v' + items[i].variant_id] = true;
    }
    return m;
  }
  function poolOffers(cart) {
    var items = (cart && cart.items) ? cart.items : [];
    var inCart = {};
    for (var i = 0; i < items.length; i++) {
      if (items[i].handle) inCart[items[i].handle] = true;
      if (items[i].variant_id) inCart['v' + items[i].variant_id] = true;
    }
    var cutSlots = MAX_CARDS - 1; /* last slot is the pantry caboose */
    var OVER = 2;                 /* over-select so post-hydrate sellouts still fill the band */

    /* 1) PAIRED CUTS LEAD — recomputed from the current cart every render.
       Over-selected too, so a sold-out paired cut is replaced by the NEXT
       paired cut, not by a random filler (render trims the front). */
    var out = cutPairsFor(cart, items, inCart, cutSlots + OVER);

    /* 2) SHUFFLE FILL — the session-frozen ORDER of configured cuts (+ one
       premiere near the top on a 1-in-4 roll). Frozen once so the filler
       cards don't churn under the customer; in-cart / sold-out entries are
       skipped at use, so the order itself never needs rewriting. */
    var order = loadFixed();
    if (!order || !order.length) {
      var cuts = [], prem = [];
      for (var key in PRODUCTS) {
        if (!Object.prototype.hasOwnProperty.call(PRODUCTS, key)) continue;
        if (!Object.prototype.hasOwnProperty.call(FARM_PICKS, key)) continue; /* configured specials only */
        if (ACCESSORY[key] || PAIRING_ONLY[key]) continue; /* pantry + pairing-only cuts never fill */
        if (PREMIERE[key]) prem.push(key); else cuts.push(key);
      }
      order = seededShuffle(cuts);
      if (PREMIERE_ROLL && prem.length) order.splice(Math.min(1, order.length), 0, seededShuffle(prem)[0]);
      saveFixed(order);
    }
    var need = (cutSlots + OVER) - out.length; /* shuffle only tops up what pairings left open */
    for (var o = 0; o < order.length && need > 0; o++) {
      var fh = offerable(order[o], inCart);
      if (!fh || out.indexOf(fh) !== -1) continue;
      out.push(fh); need--;
    }

    /* 3) CABOOSE — paired pantry candidates first, then random configured
       pantry items as stand-ins. Up to two ride along so a sold-out primary
       still leaves a pantry card (render keeps the FIRST surviving pantry
       item, never promotes a cut into the slot). Recomputed every render. */
    var cab = pantryPairFor(cart, items, inCart);
    var pantry = [];
    for (var pk in PRODUCTS) {
      if (!Object.prototype.hasOwnProperty.call(PRODUCTS, pk)) continue;
      if (!ACCESSORY[pk] || PAIRING_ONLY[pk]) continue;
      if (offerable(pk, inCart) && cab.indexOf(pk) === -1) pantry.push(pk);
    }
    cab = cab.concat(seededShuffle(pantry)).slice(0, 2);
    for (var c = 0; c < cab.length; c++) if (out.indexOf(cab[c]) === -1) out.push(cab[c]);
    return out;
  }

  /* returns array of product keys to offer (may be empty) */
  function evaluate(cart) {
    var items = (cart && cart.items) ? cart.items : [];
    if (!items.length) return [];
    if (hasFarmPicks()) return poolOffers(cart);

    var inCart = {}; /* handles + variant ids already in cart */
    var i;
    for (i = 0; i < items.length; i++) {
      if (items[i].handle) inCart[items[i].handle] = true;
      if (items[i].variant_id) inCart['v' + items[i].variant_id] = true;
    }

    var offers = [];
    var seen = {};
    function push(list) {
      for (var k = 0; k < list.length; k++) {
        var key = list[k];
        var p = PRODUCTS[key];
        if (!p || seen[key]) continue;
        if (inCart[p.handle] || inCart['v' + p.variantId]) continue; /* never offer what's in the cart */
        seen[key] = true;
        offers.push(key);
      }
    }

    var matchedAny = false;
    for (var r = 0; r < RULES.length; r++) {
      var rule = RULES[r];
      var hit = false;
      for (i = 0; i < items.length; i++) {
        if (items[i].handle && ACCESSORY[items[i].handle]) continue; /* accessories never trigger rules; cuts do */
        var text = lineText(items[i]);
        if (rule.exclude && rule.exclude.length && anyKeyword(text, rule.exclude)) continue;
        if (anyKeyword(text, rule.match)) { hit = true; break; }
      }
      if (hit) {
        matchedAny = true;
        push(rule.offer);
      }
    }
    if (!matchedAny) push(FALLBACK_OFFER);

    return offers.slice(0, MAX_CARDS);
  }

  /* ------------------------------------------------------------
   * Rendering
   * ---------------------------------------------------------- */
  function findMount() {
    /* Integration can finalize the mount by adding data-n36-pairs-mount
       to any element inside the drawer; the band becomes its last child. */
    var explicit = document.querySelector('[data-n36-pairs-mount]');
    if (explicit) return { parent: explicit, before: null };

    /* Default: the END of the SCROLLING items region (cart-drawer-items),
       not the footer. Asher 2026-08-15: the checkout button must always be
       in view AND the upsells must not be skippable — so the band rides
       right after the last line item in the scroll path, and the pinned
       footer stays slim (totals + note + checkout only). */
    var scroller = document.querySelector('#CartDrawer cart-drawer-items');
    if (scroller) return { parent: scroller, before: null };
    var footer = document.querySelector('#CartDrawer .drawer__footer');
    if (!footer) return null;
    return { parent: footer, before: footer.firstChild };
  }

  function removeBand() {
    var el = document.getElementById(BAND_ID);
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  /* Farm Specials config (handle -> {type,value}) from the theme's JSON island
     (#n36-farm-picks-config), written by `npm run sync-picks` from the discount
     config — the SAME source the discount function reads, so the card never
     promises a price checkout won't honor. Absent/null => no deals shown.
     (The preview-only hardcoded demo config was retired at the 2026-08-21 flip.) */
  var FARM_CFG = (function () {
    try {
      var el = document.getElementById('n36-farm-picks-config');
      if (!el) return {};
      return JSON.parse(el.textContent || 'null') || {};
    } catch (e) { return {}; }
  })();
  var FARM_PICKS = (FARM_CFG && FARM_CFG.picks && typeof FARM_CFG.picks === 'object') ? FARM_CFG.picks : {};

  /* TEMPORARY — SALE PRICE SNAP (Asher 2026-08-22, Weeknight Classics sale).
     While the synced config carries a `sale` block, a card whose OFFERED
     variant is a sale item shows the SALE price (struck regular -> sale),
     matching what the discount function charges, instead of the Farm Special
     math (which would under-promise, e.g. Ground Beef $10 vs sale $9).
     Shown regardless of the anchor/bundle gates because the function charges
     the sale regardless. Self-disables when `sale.ends` passes (browser-local
     date; the function uses the store date — same day in practice) or when
     the sale block is removed from farm-picks.json and re-synced.
     TO REMOVE after the sale: delete this block + the `sale` param use in
     makeCard (see FARM-SPECIALS.md "Sale snap"). */
  var SALE_CFG = (FARM_CFG && FARM_CFG.sale && FARM_CFG.sale.items && typeof FARM_CFG.sale.items === 'object') ? FARM_CFG.sale : null;
  function localDateStr() {
    var d = new Date(), m = d.getMonth() + 1, day = d.getDate();
    return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
  }
  /* whole-dollar sale price for the card's offered variant, or null */
  function salePriceFor(p) {
    if (!SALE_CFG || !p || !p.variantId) return null;
    if (SALE_CFG.ends && localDateStr() > String(SALE_CFG.ends)) return null;
    var it = SALE_CFG.items['gid://shopify/ProductVariant/' + p.variantId];
    if (!it || !(Number(it.price) > 0)) return null;
    var out = Math.round(Number(it.price) / 100);
    return out < p.price ? out : null;
  }
  function hasFarmPicks() {
    for (var k in FARM_PICKS) { if (Object.prototype.hasOwnProperty.call(FARM_PICKS, k)) return true; }
    return false;
  }
  /* deal price for a whole-dollar real price, or null if this handle isn't on
     special. Fixed amount is exact; percent rounds to a whole dollar for DISPLAY
     (fixed amounts are the signed convention, so card == checkout to the cent). */
  function dealPrice(handle, real) {
    if (!Object.prototype.hasOwnProperty.call(FARM_PICKS, handle)) return null;
    var pick = FARM_PICKS[handle];
    var v = Number(pick && typeof pick === 'object' ? pick.value : pick);
    if (!(v > 0)) return null;
    var out = (pick && typeof pick === 'object' && String(pick.type).toLowerCase().indexOf('percent') === 0)
      ? Math.round(real * (1 - Math.min(v, 100) / 100))
      : real - v;
    if (!(out >= 0) || out >= real) return null;
    return out;
  }

  /* A card only shows its struck/deal price when the cart has an ANCHOR — a
     line that is neither a farm pick nor the gift — because the discount
     function only applies the special then (Asher 2026-08-21, option A). No
     anchor => cards show full price, so the card never promises a deal the
     cart won't honor. Mirrors the function's anchor rule exactly. */
  /* A card shows its deal price only when the cart has an ANCHOR — a line that
     is neither a farm pick nor the gift — because the discount function applies
     the special only then (Asher 2026-08-21, option A). No anchor => full price,
     so the card never promises a deal the cart won't honor. */
  /* A farm pick carries EITHER key (rename 2026-09-22): '_Farm Special' is what
     the band writes now; '_n36_farm_pick' is on carts built before the switch.
     Read both, exactly like the discount function, or a pick of one key would
     count as the other's anchor. Keep the old-key read 30+ days. */
  function cartHasAnchor(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var pr = items[i].properties || {};
      if (!pr._n36_farm_pick && !pr['_Farm Special'] && !pr._n36_free_steak) return true;
    }
    return false;
  }

  /* Any bundle (a _rc_bundle line) in the cart turns Farm Specials OFF (Asher
     2026-08-21: a bundle is already the discount tier). Today that's BYB only;
     Latitude isn't a bundle yet so it keeps its specials, and it auto-blocks the
     day it becomes one (Asher: "fine with blocking Latitude later"). */
  function cartHasBundle(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].properties && items[i].properties._rc_bundle) return true;
    }
    return false;
  }

  function makeButton(product) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = 'Add';
    btn.setAttribute('aria-label', 'Add ' + product.title + ' to cart');
    /* stable width so the label changing (Add -> ... -> Added) never widens the
       button and shoves the price past the fixed-width card edge on a phone
       (Asher 2026-08-21); any longer state ellipsis-clips instead of overrunning */
    btn.style.cssText =
      'flex:0 0 auto;box-sizing:border-box;min-width:46px;max-width:58px;text-align:center;' +
      'white-space:nowrap;overflow:hidden;text-overflow:ellipsis;' +
      'background:' + C.oxblood + ';color:' + C.linen +
      ';border:0;border-radius:5px;padding:5px 8px;font-size:10px;font-weight:700;' +
      'letter-spacing:.04em;text-transform:uppercase;cursor:pointer;font-family:' + BODY_FONT + ';';
    btn.onclick = function () {
      if (btn.disabled) return;
      btn.disabled = true;
      btn.textContent = '\u2026'; /* ellipsis while the add is in flight; word 'Adding' overran the card */
      btn.style.opacity = '.7';
      /* through window.fetch so the plumbing's hook auto-refreshes the drawer */
      window.fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        /* '_Farm Special' reads cleanly on the admin order line; the leading
           underscore keeps it out of the drawer, checkout and order status
           (the "Farm Special" discount label already shows there). Was
           '_n36_farm_pick': '1' until 2026-09-22; the function accepts both. */
        body: JSON.stringify({ items: [{ id: product.variantId, quantity: 1, properties: { '_Farm Special': 'Yes' } }] })
      }).then(function (res) {
        if (res && res.ok) {
          btn.textContent = 'Added';
          /* plumbing re-dispatches n36cart:updated; the band re-renders
             and this product drops out on its own */
        } else {
          btn.textContent = 'Unavailable';
        }
      }).catch(function () {
        btn.disabled = false;
        btn.style.opacity = '1';
        btn.textContent = 'Add';
      });
    };
    return btn;
  }

  function makeCard(p, showDeal) {
    var card = document.createElement('div');
    card.style.cssText =
      'flex:0 0 auto;width:118px;scroll-snap-align:start;display:flex;flex-direction:column;background:' + C.surface +
      ';border:1px solid ' + C.line + ';border-radius:6px;padding:7px;text-align:center;';

    var img = document.createElement('img');
    if (p.image) img.src = p.image;
    img.alt = p.title;
    img.loading = 'lazy';
    img.width = 160;
    img.height = 120;
    img.style.cssText =
      'width:100%;height:46px;object-fit:cover;border-radius:4px;display:block;background:' + C.linen + ';';
    card.appendChild(img);

    var title = document.createElement('div');
    title.textContent = p.title;
    title.title = p.title; /* full name on hover (desktop) */
    /* two-line clamp instead of a one-line ellipsis (Asher 2026-08-21: "Assorted
       Box of…" was getting cut); cards are align-items:stretch and the price/Add
       row is margin-top:auto, so a 2-line title never misaligns the row */
    title.style.cssText =
      'font-size:11px;line-height:1.25;color:' + C.slate + ';margin:5px 0 3px;font-weight:600;' +
      'display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:2.5em;';
    card.appendChild(title);

    var foot = document.createElement('div');
    foot.style.cssText = 'display:flex;align-items:center;justify-content:space-between;gap:5px;margin-top:auto;';
    var sale = salePriceFor(p); /* TEMPORARY sale snap — see SALE_CFG */
    var deal = sale != null ? sale : (showDeal ? dealPrice(p.handle, p.price) : null);
    var price = document.createElement('div');
    if (deal != null) {
      /* struck real price (slate) + oxblood deal price — oxblood = savings, house doctrine */
      var was = document.createElement('span');
      was.textContent = '$' + p.price;
      was.style.cssText = 'display:block;color:' + C.slate + ';text-decoration:line-through;opacity:.7;font-weight:600;font-size:10.5px;line-height:1.05;';
      var now = document.createElement('span');
      now.textContent = '$' + deal;
      now.style.cssText = 'display:block;color:' + C.oxblood + ';font-weight:700;font-size:13px;line-height:1.05;';
      price.appendChild(was);
      price.appendChild(now);
      /* struck price STACKED over the deal price: the column is only as wide as one
         number, so a 3-digit compare-at ($100) never crowds the Add button (Asher 2026-08-21) */
      price.style.cssText = 'display:flex;flex-direction:column;align-items:flex-start;flex:0 0 auto;';
    } else {
      price.textContent = '$' + p.price; /* whole dollars only, house rule */
      price.style.cssText = 'font-size:13px;flex:0 0 auto;white-space:nowrap;color:' + C.oxblood + ';font-weight:700;';
    }
    foot.appendChild(price);
    foot.appendChild(makeButton(p));
    card.appendChild(foot);
    return card;
  }

  /* live product data, cached per page load: price + image + availability
     from /products/<handle>.js so cards are never stale and sold-out cuts
     silently drop out of the band */
  var HYD = {};
  function hydrate(key) {
    if (HYD[key]) return HYD[key];
    var base = PRODUCTS[key];
    HYD[key] = window.fetch('/products/' + base.handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (prod) {
        var v = null, vs = prod.variants || [];
        for (var i = 0; i < vs.length; i++) {
          if (vs[i].id === base.variantId) { v = vs[i]; break; }
        }
        var fellBack = false;
        if (!v || v.available === false) {
          /* pinned size sold out: fall back to the cheapest AVAILABLE size so the
             special stays on offer (2026-08-21: outside skirt 2 lb out, 3 lb in) */
          var best = null;
          for (var k = 0; k < vs.length; k++) {
            if (vs[k].available && (!best || Number(vs[k].price) < Number(best.price))) best = vs[k];
          }
          if (best) { v = best; fellBack = true; }
        }
        if (!v) return { key: key, p: base, available: false };
        var img = (v.featured_image && v.featured_image.src) || prod.featured_image || (prod.images && prod.images[0]) || base.image || null;
        return {
          key: key,
          available: v.available !== false,
          p: {
            title: fellBack ? ((prod.title || base.title) + ' ' + (v.title || '')).trim() : base.title,
            handle: base.handle,
            variantId: v.id,
            price: Math.round(Number(v.price) / 100) || base.price, /* product.js prices are cents */
            image: img
          }
        };
      })
      ['catch'](function () {
        /* network hiccup: fall back to the static roster, assume sellable */
        return { key: key, p: base, available: true };
      });
    return HYD[key];
  }

  /* Every band add is a special (function selectionStrategy ALL since the
     2026-08-21 ~07:00 deploy; the brief one-special-per-cart gate was
     removed the same hour — Asher: "let people add more from the special"). */
  /* Final card order from the post-hydrate survivors: cuts in selection order
     (paired first) up to MAX_CARDS-1, then the FIRST surviving pantry item as
     the caboose. If no pantry item survived, cuts may take the last slot; a
     cut is never mistaken for the caboose by position (review fix 2026-08-22). */
  function arrangeLive(live) {
    var cuts = [], pantry = [];
    for (var i = 0; i < live.length; i++) {
      if (live[i] && ACCESSORY[live[i].handle]) pantry.push(live[i]); else cuts.push(live[i]);
    }
    if (!pantry.length) return cuts.slice(0, MAX_CARDS);
    /* Smashburger Press leads on burger carts (Asher 2026-10-23: "move the press up to
       first position"). It is pairing-only, so it is only ever here because ground
       beef or burgers are in the cart; as the caboose it sat off-screen in the row. */
    if (pantry[0].handle === 'smashburger-press') return [pantry[0]].concat(cuts.slice(0, MAX_CARDS - 1));
    return cuts.slice(0, MAX_CARDS - 1).concat([pantry[0]]);
  }

  function render(cart) {
    var items = (cart && cart.items) ? cart.items : [];
    if (!items.length) { removeBand(); return; }

    /* A frozen visible set exists for this session: reuse it, drop whatever is
       now in the cart, NEVER top up. No recompute, no refill (Asher 2026-09-04). */
    var shown = loadShown();
    if (shown && shown.length) {
      var inCart = inCartMap(items);
      var keep = [];
      for (var k = 0; k < shown.length; k++) if (offerable(shown[k], inCart)) keep.push(shown[k]);
      if (!keep.length) { removeBand(); return; } /* all five added = band retires; that IS the cap */
      Promise.all(keep.map(hydrate)).then(function (hyd) {
        var live = [];
        for (var i = 0; i < hyd.length; i++) if (hyd[i] && hyd[i].available) live.push(hyd[i].p);
        renderCards(cart, live); /* order already fixed on first paint; no re-trim */
      });
      return;
    }

    /* First paint this session: draw normally (pairings + shuffle + caboose),
       then freeze exactly the cards shown as THE offers for the session. */
    var offers = evaluate(cart);
    if (!offers.length) { removeBand(); return; }
    Promise.all(offers.map(hydrate)).then(function (hyd) {
      var live = [];
      for (var i = 0; i < hyd.length; i++) if (hyd[i] && hyd[i].available) live.push(hyd[i].p);
      live = arrangeLive(live);
      if (live.length) saveShown(live.map(function (p) { return p.handle; }));
      renderCards(cart, live);
    });
  }

  function renderCards(cart, products) {
    removeBand();
    if (!products.length) return;

    var mount = findMount();
    if (!mount) return; /* drawer not in DOM; nothing to do */

    var showDeals = cartHasAnchor(cart) && !cartHasBundle(cart);

    /* Build fully populated BEFORE inserting — never an empty div. */
    var band = document.createElement('div');
    band.id = BAND_ID;
    band.style.cssText =
      'margin:4px 0 12px;padding:9px 10px 8px;background:' + C.linen +
      ';border:1px solid ' + C.lineSoft + ';border-radius:8px;font-family:' + BODY_FONT + ';';

    var headRow = document.createElement('div');
    headRow.style.cssText = 'display:flex;align-items:center;justify-content:space-between;margin:0 0 8px;';
    var heading = document.createElement('div');
    heading.textContent = hasFarmPicks() ? BAND_TITLE : BAND_TITLE_PLAIN;
    heading.style.cssText =
      'font-size:11px;letter-spacing:.12em;text-transform:uppercase;font-weight:700;color:' +
      C.olive + ';';
    headRow.appendChild(heading);

    var row = document.createElement('div');
    row.className = 'n36-pw-lane';
    row.style.cssText = 'display:flex;gap:8px;align-items:stretch;overflow-x:auto;' +
      'scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none;';
    for (var i = 0; i < products.length; i++) row.appendChild(makeCard(products[i], showDeals));

    /* desktop chevrons ride the middle sides of the carousel, centered on
       the card images (homepage pattern, Asher 2026-08-16). The viewport
       wraps the lane; the buttons are siblings so the lane's overflow-x
       never clips them. CSS positions/sizes/hides-on-touch; JS hides them
       when nothing overflows. Mouse users can't swipe. */
    var viewport = document.createElement('div');
    viewport.className = 'n36-pw-viewport';
    viewport.appendChild(row);
    function chev(dir, glyph, side) {
      var wrap = document.createElement('div');
      wrap.className = 'n36-pw-nav-side ' + side;
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = glyph;
      b.setAttribute('aria-label', dir > 0 ? 'Next suggestions' : 'Previous suggestions');
      b.onclick = function () { row.scrollBy({ left: dir * 126, behavior: 'smooth' }); };
      wrap.appendChild(b);
      return wrap;
    }
    var navPrev = chev(-1, '‹', 'prev');
    var navNext = chev(1, '›', 'next');
    viewport.appendChild(navPrev);
    viewport.appendChild(navNext);
    band.appendChild(headRow);
    band.appendChild(viewport);
    /* per-end hide: no left arrow at the start, no right arrow at the end,
       and both gone when nothing overflows (Asher 2026-08-21) */
    function updateArrows() {
      if (row.scrollWidth <= row.clientWidth + 4) {
        navPrev.style.display = 'none';
        navNext.style.display = 'none';
        return;
      }
      var max = row.scrollWidth - row.clientWidth;
      navPrev.style.display = row.scrollLeft <= 2 ? 'none' : '';
      navNext.style.display = row.scrollLeft >= max - 2 ? 'none' : '';
    }
    row.addEventListener('scroll', updateArrows, { passive: true });
    setTimeout(updateArrows, 60);

    if (mount.before) mount.parent.insertBefore(band, mount.before);
    else mount.parent.appendChild(band);

    /* Dawn's section rendering can replace the drawer's innerHTML right
       after a cart update and silently wipe the band. One bounded retry:
       if the band is gone 600ms after we placed it, mount it once more. */
    setTimeout(function () {
      if (!document.getElementById(BAND_ID)) {
        var again = findMount();
        if (again) {
          if (again.before) again.parent.insertBefore(band, again.before);
          else again.parent.appendChild(band);
        }
      }
    }, 600);
  }

  function fetchCartAndRender() {
    window.fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) { render(cart); })
      .catch(function () { /* leave whatever is currently rendered */ });
  }

  /* ------------------------------------------------------------
   * Wiring
   * ---------------------------------------------------------- */
  var debounceTimer = null;
  document.addEventListener('n36cart:updated', function (evt) {
    var detail = evt && evt.detail;
    var cart = (detail && detail.items) ? detail
      : (detail && detail.cart && detail.cart.items) ? detail.cart
      : null;
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      if (cart) render(cart);
      else fetchCartAndRender();
    }, 120);
  });

  /* initial paint */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchCartAndRender);
  } else {
    fetchCartAndRender();
  }
})();
